export default __webpack_public_path__ + "static/media/wallet-new.b9c586a3.svg";